export default __webpack_public_path__ + "static/media/q19_04.22f215fd.png";